/* eslint-disable camelcase */
import { WithdrawalFeesDto } from '@core/mappers/user/dtos/WithdrawalFeesDto';
import { WithdrawalFees } from '@models/user/withdrawal/WithdrawalFees';

export interface WithdrawalAbility {
    isOnlineEligible: boolean;
    isShopEligible: boolean;
    isBankTransferEligible: boolean;
    isTransaksEligible: boolean;
    willAnyBonusExpire: boolean;
    bonusesToExpire: string[];
    withdrawalFees: WithdrawalFees | null;
    lastBankAccountUsed?: LastBankAccountUsed;
}

export interface WithdrawalAbilityDto {
    EligibleForOnlineWithdrawal: boolean;
    EligibleForBankTransferWithdrawal: boolean;
    EligibleForCicoWithdrawal: boolean;
    LastBankAccountUsed: {
        meta_data?: LastBankAccountUsedDto;
    };
    WithdrawalFees: WithdrawalFeesDto;
    BonusesToExpire: BonusToExpireDto[];
}

export interface BonusToExpireDto {
    BonusIncetiveFriendlyName: string; // TODO: check if `incetive` is a typo or that's how it comes in the response
}

export interface LastBankAccountUsedDto {
    account_reference: string;
}

export interface LastBankAccountUsed {
    accountReference: string;
}

export const AccountData = {
    AccountReference: 'account_reference',
    HolderName: 'holder_name',
} as const;
export type AccountData = typeof AccountData[keyof typeof AccountData];
